import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-[#1C1917] border border-[#E7E5E4] shadow-lg rounded-lg",
          description: "text-[#78716C]",
          actionButton:
            "bg-[#1C1917] text-white",
          cancelButton:
            "bg-[#F5F5F4] text-[#44403C]",
          success: "bg-white border-green-200",
          error: "bg-white border-red-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
